<template>
  <section v-if="inclusions.length > 0">
    <div class="inclusions-items">
      <div
        v-for="(inclusion, index) of inclusions"
        :key="index"
        class="pt-2 pb-2"
      >
        <div class="is-flex is-justify-content-space-between">
          <div class="is-flex is-align-items-center">
            <v-input-switch
              v-model="propertyInclusion[index].status"
              label=""
              :true-value="true"
              :false-value="false"
              name="status"
              @input="onInputChange($event, 'status', inclusion.id)"
            />
            <h6 class="mr-4">
              {{ inclusion.inclusion_label.capitalize() }}
            </h6>
          </div>

          <a
            :aria-controls="`inclusions_collapse_${inclusion.id}`"
            :aria-expanded="
              propertyInclusionsCollapseStatus.includes(inclusion.id)
            "
            @click="managePropertyInclusionsCollapse(inclusion.id)"
          >
            <button class="button is-white is-small" type="button">
              <b-icon
                v-if="propertyInclusionsCollapseStatus.includes(inclusion.id)"
                icon="mdi mdi-18px mdi-chevron-up"
              />
              <b-icon
                v-if="!propertyInclusionsCollapseStatus.includes(inclusion.id)"
                icon="mdi mdi-18px mdi-chevron-down"
              />
            </button>
          </a>
        </div>
        <b-collapse
          :open="propertyInclusionsCollapseStatus.includes(inclusion.id)"
          animation="slide"
          :aria-id="`inclusions_collapse_${inclusion.id}`"
        >
          <v-input-rich-text
            v-model="propertyInclusion[index].notes"
            name="notes"
            @input="onInputChange($event, 'notes', inclusion.id)"
          />
        </b-collapse>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    inclusions: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      propertyInclusionsCollapseStatus: [],
      propertyInclusion: [],
    };
  },
  created() {
    this.propertyInclusion = this.inclusions;
  },
  methods: {
    onInputChange(inputValue, index, inclusionId) {
      this.$emit("updated", inclusionId, index, inputValue);
    },

    managePropertyInclusionsCollapse(inclusionId) {
      const index = this.propertyInclusionsCollapseStatus.indexOf(inclusionId);
      if (index < 0) {
        this.propertyInclusionsCollapseStatus.push(inclusionId);
      } else {
        this.propertyInclusionsCollapseStatus.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.inclusions-items .field {
  margin: 0 !important;
}
</style>
